import {Component, OnInit} from '@angular/core';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../../../../services/auth.service';
import { TokenStorageService } from '../../../../../services/token-storage.service';
import { Router } from '@angular/router'
@Component({
  selector: 'app-nav-right',
  templateUrl: './nav-right.component.html',
  styleUrls: ['./nav-right.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavRightComponent implements OnInit {

  constructor(private authservice: AuthService, private route: Router, private tokenStoraS : TokenStorageService ) { }

   user = this.tokenStoraS.getUser();
  // console.log(user.name);
  

  ngOnInit() {

   }

  
 
  exitPlat(){
     this.authservice.logout().subscribe(
      data => {

        console.log(data.message);
    
        if(data.message){
          this.tokenStoraS.signOut();
          this.route.navigate([''])
        }

      },
      err => {
        // alert('no se hizo desloquego'+err.error.message);
        this.route.navigate(['']);
      }
    );
  }

}
